<!-- @format -->

@if (isLoading()) {
	@for (_ of [1, 2, 3]; track $index) {
		<hmf-skeleton
			class="hmf-display-block"
			[class.hmf-mb-xxs]="!$last"
			width="100%"
			height="56px"
			borderRadius="0"
			[loading]="true">
		</hmf-skeleton>
	}
} @else if (isError()) {
	<hmf-alert-banner
		type="alert"
		title="Oops! Something Went Wrong"
		message="We encountered an issue loading the protection plan options. Please refresh the page and try again. If the problem persists, "
		link="/s/help-desk"
		linkTitle="please contact support"
	/>
	<!-- No warranties, disabled no plan available button only -->
} @else if (warranties().length === 0) {
	<button
		class="disabled-button hmf-display-flex hmf-align-items-center hmf-p-s background-base hmf-w-100"
		disabled>
		<div class="hmf-body-bold-m">No Plan Available</div>
	</button>
	<!-- 1-3 warranties + no plan option -->
} @else if (warranties().length <= 3) {
	@for (warranty of warranties(); track warranty.planSku) {
		@let isSelected = selectedPlanSku() === warranty.planSku;
		<hmf-selector
			class="hmf-mb-xs"
			[contained]="true"
			[selector]="'rectangular'"
			[width]="'100%'"
			[ariaLabel]="'Select {{ warranty.planDisplayName }}'"
			[selected]="isSelected"
			(click)="setSelectedPlanSku(warranty)"
			(keyup.enter)="setSelectedPlanSku(warranty)"
			tabindex="0">
			<div
				class="hmf-display-flex hmf-flex-row hmf-justify-content-between hmf-align-items-center hmf-w-100 hmf-p-s"
				ngProjectAs="rectangularSelectorBody">
				<div
					[class.hmf-body-m]="!isSelected"
					[class.hmf-body-bold-m]="isSelected"
					class="hmf-text-align-left">
					{{ warranty.planDisplayName }}
				</div>
				<div
					class="hmf-ml-s"
					[class.hmf-body-m]="!isSelected"
					[class.hmf-body-bold-m]="isSelected">
					{{ warranty.sellingPrice | currency }}
				</div>
			</div>
		</hmf-selector>
	}

	@let isNoPlanSelected = selectedPlanSku() === null;
	<hmf-selector
		[contained]="true"
		[selector]="'rectangular'"
		[width]="'100%'"
		[ariaLabel]="'Select No Plan'"
		[selected]="isNoPlanSelected"
		(click)="selectedPlanSku.set(null)"
		(keyup.enter)="selectedPlanSku.set(null)"
		tabindex="0">
		<div
			class="hmf-display-flex hmf-flex-row hmf-w-100 hmf-p-s"
			ngProjectAs="rectangularSelectorBody">
			<div>
				<span
					[class.hmf-body-m]="!isNoPlanSelected"
					[class.hmf-body-bold-m]="isNoPlanSelected"
					>No Plan</span
				>
			</div>
		</div>
	</hmf-selector>
	<!-- 4+ warranties + no plan -->
} @else {
	<hmf-select
		class="warranty-plan-select"
		ariaLabel="Select a Plan"
		[isLabelInside]="true"
		variant="primary"
		size="large"
		optionDesign="label"
		[dropdownList]="hmfSelectOptions()"
		[ngModel]="selectedPlanLabelForHmfSelect()"
		(handleIndividualCheckedList)="handleHmfSelectChange($event)"
		[isMobile]="false"
		[isMultipleChoice]="false"
		[isError]="false">
	</hmf-select>
}
